<script setup>
import IconArrow14 from '@/components/svg/IconArrow14.vue'
import { useDeviceDetect } from '@/composables/useDeviceDetect'

const { isMobile } = useDeviceDetect();
const props = defineProps({

})
</script>

<template>
  <div class="youngsin-wrapper">
    <div class="yg-guide-box st-guide-01-right">
      <div class="text-guide-right-01">
        <div class="yg-text-01">
          이러한 과정을 통해 제공되는 낭만만세력의 용신분석 데이터는 <br />
          <span class="txt-bold">오행 분포 · 신강신약 · 조후 · 격국 · 대운 흐름</span>을
          종합하여,<br />
          현재 명식에서 주목할 만한 <span class="txt-bold">핵심 오행과 그 보조 · 제어 관계</span>를
          보여줍니다.
        </div>
        <div class="yg-text-01">
          또한 희신 · 기신 · 구신 · 한신의 상호작용과 격국 패턴과 함께,<br />향후 대운 흐름속에서
          참고할 방향성을 함께 분석하여 제공하고 있습니다.
        </div>
      </div>
      <div class="yg-text-graybox">
        <span class="yg-text-03">“이 명식은 왜 수(水)를 중심으로 균형을 맞추어야 하는가?”</span>
        <span class="yg-text-01">와 같은 질문에 대한 근거를 직관적으로 확인할 수 있습니다.</span>
      </div>
    </div>
    <div class="gap-40"></div>
    <div class="yg-guide-img-0101"></div>
    <div class="gap-40"></div>
    <div class="yg-text-01">
      이 분석이 연구와 실제 상담을 준비하는 과정에서 <br />다양한 시각을 얻는 데 작은 도움이 되길
      바랍니다.
    </div>
    <div class="gap-40"></div>
    <div class="guide-outro-youngsin">
      <div class="img-box"></div>
      <div class="guide-outro__content" :class="{mobile: isMobile}">
        <div class="guide-outro__title">낭만만세력은</div>
        <div class="guide-outro__text">
          앞으로도 사주명리의 핵심 가치를 사랑하고 <br />연구 발전에 힘쓰시는 모든 분들께 작은
          보탬이 될 수 있도록 지속적으로 의견을 듣고 개선하며 나아가겠습니다.
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '@/assets/nangman_style/_analysis_main_color.scss';
.youngsin-wrapper {
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.gap-40 {
  padding-top: 40px;
}
.st-guide-01-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}
.yg-text-01 {
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  .txt-bold {
    color: $analysis-yongsin;
  }
}
.text-guide-right-01 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.yg-text-03 {
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.yg-text-graybox {
  display: flex;
  flex-direction: column;
  padding: 12px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  background: var(--Gray-200, #f8f8f8);
}
.yg-guide-img-0101 {
  width: 100%;
  height: 180px;
  background-image: url('@manseImages/yg-guide-0101.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.guide-outro-youngsin {
  display: flex;
  padding: 20px 32px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border-radius: 12px;
  background: $analysis-yongsin-light;
  .img-box {
    background-image: url('@manseImages/pet-youngsin.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 120px;
    height: 120px;
    min-width: 120px;
    min-height: 120px;
    flex-shrink: 0;
    flex-basis: 120px;
  }
  .guide-outro__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    &.mobile{
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    .guide-outro__title {
      color: $analysis-yongsin;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 160% */
    }
    .guide-outro__text {
      color: var(--Gray-800, #333);
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 160% */
    }
  }
}
@media (max-width: 768px) {
  .yg-guide-img-0101 {
    background-image: url('@manseImages/yg-guide-0101-mobile.png');
  }
}
</style>
